import React from 'react';
import { componentService } from 'js/services/component.service';

export const BrokenGamesHistory = React.lazy(() => import(/* webpackChunkName: "broken-games-history" */ '././BrokenGamesHistory'));

componentService.registerPageComponents({ 'broken-games-history': BrokenGamesHistory });
